import React from 'react';
import { LiveSearchDatabaseStoryblok, LiveSearchLinksStoryblok } from '../../../_shared/interfaces/storyblok';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import { search } from 'ss-search';
import { LSLinksSearchDatabase, LSProductsSearchDatabase, LSSearchResult } from './header-live-search.types';

export const getProductSearchDatabases = (
    databases: LiveSearchDatabaseStoryblok[],
    storyblokCommon: StoryblokCommon,
): LSProductsSearchDatabase[] => {
    const searchDatabases: LSProductsSearchDatabase[] = [];
    databases.forEach((i) => {
        const blacklist = i.manufacturers_blacklist ? i.manufacturers_blacklist.split('\n') : [];
        const database =
            i.data === 'workshopServices'
                ? storyblokCommon.workshopServices.content.manufacturer
                : i.data === 'onSiteServices' && storyblokCommon.onSiteServices
                ? storyblokCommon.onSiteServices.content.manufacturer
                : undefined;
        if (database) {
            const d: LSProductsSearchDatabase = { headline: i.name, link: i.link.cached_url, searchEntries: [] };

            database.forEach((m) => {
                if (!blacklist.includes(m.name)) {
                    m.products.forEach((p) => {
                        p.services.forEach((s) => {
                            d.searchEntries.push({
                                manufacturer: m.name,
                                manufacturerId: m.name,
                                product: p.name,
                                category: p.category,
                                service: s.name,
                            });
                        });
                    });
                }
            });
            searchDatabases.push(d);
        }
    });
    return searchDatabases;
};

export const getLinkSearchDatabases = (databases: LiveSearchLinksStoryblok[]): LSLinksSearchDatabase[] => {
    const searchDatabases: LSLinksSearchDatabase[] = [];
    databases.forEach((i) => {
        const d: LSLinksSearchDatabase = { headline: i.category, searchEntries: [] };
        i.links.forEach((l) => {
            d.searchEntries.push({ category: i.category, text: l.text, link: l.link.cached_url, keywords: l.keywords ?? '' });
        });
        searchDatabases.push(d);
    });
    return searchDatabases;
};

export const getProductsSearchResult = (searchString: string, databases: LSProductsSearchDatabase[]): LSSearchResult[] => {
    const searchResults: LSSearchResult[] = [];
    databases.forEach((database) => {
        const result = search(
            database.searchEntries,
            ['manufacturer', 'product', 'category', 'service'],
            normalizeSearchString(searchString),
        );

        if (result.length) {
            const searchResult: LSSearchResult = { headline: database.headline, results: [] };

            result.forEach((r) => {
                const res = 'element' in r ? r.element : r;
                searchResult.results.push({
                    text: `${res.product} (${res.service})`,
                    link: `/${database.link}?m=${res.manufacturerId}&p=${res.product}&s=${res.service}`,
                });
            });

            searchResults.push(searchResult);
        }
    });
    return searchResults;
};

export const getLinksSearchResult = (searchString: string, databases: LSLinksSearchDatabase[]): LSSearchResult[] => {
    const searchResults: LSSearchResult[] = [];

    databases.forEach((database) => {
        const result = search(database.searchEntries, ['category', 'text', 'keywords'], normalizeSearchString(searchString));

        if (result.length) {
            const searchResult: LSSearchResult = { headline: database.headline, results: [] };

            result.forEach((r) => {
                const res = 'element' in r ? r.element : r;
                searchResult.results.push({
                    text: `${res.text}`,
                    link: `/${res.link}`,
                });
            });

            searchResults.push(searchResult);
        }
    });
    return searchResults;
};

export const normalizeSearchString = (s: string): string => {
    s = s.toLowerCase();
    s = s.replace(/ae/g, 'a');
    s = s.replace(/oe/g, 'o');
    s = s.replace(/ue/g, 'u');
    s = s.replace(/ss/g, 's');
    return s;
};
